/*document.addEventListener('DOMContentLoaded', function () {
    const gift_message1 = document.querySelector('.gift_message1');
    const gift_message2 = document.querySelector('.gift_message2');
    const message_trm1 = gift_message1.textContent.trim();
    const message_trm2 = gift_message2.textContent.trim();
    if(messamessage_trm1ge_trm!=''){
        localStorage.setItem("message1", message_trm1);
    }
    if(message_trm2!=''){
        localStorage.setItem("message2", message_trm2);
    }
});*/

document.addEventListener('click', function (e) {
  // Check if the clicked element (or one of its parents) has the class 'gift_link'
  const link = e.target.closest('.gift_link');
  if (link) {
    const hrefValue = link.getAttribute('href');
    e.preventDefault();
    const gift_mesaage = link
      ?.closest('.border-border')
      ?.nextElementSibling?.textContent.trim();
    if (gift_mesaage != '') {
      localStorage.setItem('message', gift_mesaage);
      window.location.href = hrefValue;
    }
  }
});
